import { BaseMapOptions } from 'types';

interface ActionTypes {
  GET_BASE_MAPS_START: string;
  GET_BASE_MAPS_SUCCESS: string;
  GET_BASE_MAPS_FAILURE: string;
}

export const MapStyleControllerActionTypes: ActionTypes = {
  GET_BASE_MAPS_START: '@@GET_BASE_MAPS_START',
  GET_BASE_MAPS_SUCCESS: '@@GET_BASE_MAPS_SUCCESS',
  GET_BASE_MAPS_FAILURE: '@@GET_BASE_MAPS_FAILURE'
};

export interface MapStyleControllerState {
  basemapOptions: BaseMapOptions;
  basemapError: string;
}

export default MapStyleControllerActionTypes;
